import { createAsyncThunk } from "@reduxjs/toolkit";
import ordersService from "../../../api/services/orders";

export const createOrder = createAsyncThunk(
  "orders/create-order",
  async (requestData) => {
    return await ordersService.createOrder(requestData);
  }
);

export const getOrders = createAsyncThunk(
  "orders/get-order",
  async (requestData = {}) => {
    return await ordersService.getOrders(requestData);
  }
);

export const deleteOrder = createAsyncThunk(
  "orders/delete-order",
  async (id) => {
    return await ordersService.deleteOrder(id);
  }
);

export const updateOrderStatus = createAsyncThunk(
  "orders/update-order-status",
  async (requestData) => {
    return await ordersService.updateOrderStatus(requestData);
  }
);
